import { useMemo } from "react";
import accountContext from "../../account/accountContext";
import { jwtDecode } from "jwt-decode";

interface CompanyTypeResult {
  companyType: number;
  isOperator: boolean;
  isProvider: boolean;
}

interface JwtPayloadWithCompanyType {
  company_type?: string;
  [key: string]: any;
}

const useCompanyType = (): CompanyTypeResult => {
  return useMemo(() => {
    const token = accountContext.accessToken;
    if (!token) {
      return { companyType: 0, isOperator: false, isProvider: false };
    }

    try {
      const decoded = jwtDecode<JwtPayloadWithCompanyType>(token);
      const companyType = decoded.company_type
        ? parseInt(decoded.company_type, 10)
        : 0;

      return {
        companyType,
        isOperator: (companyType & 1) !== 0,
        isProvider: (companyType & 2) !== 0,
      };
    } catch {
      return { companyType: 0, isOperator: false, isProvider: false };
    }
  }, [accountContext.accessToken]);
};

export default useCompanyType;
